export default function initRemoveViewAsQuery() {
    // If the URL has a view_as query argument remove it from the url and wipe it from history
    if (window.history.replaceState && window.location.search.indexOf('view_as') !== -1) {
        // prevents browser from storing history with each change:
        window.history.replaceState(
            {},
            window.document.title,
            window.location.href.replace(window.location.search, '')
        );
    }
}
